(function(){
  if (window.__pfpQuickMarkStableCamera) return;
  window.__pfpQuickMarkStableCamera = true;

  var activeOverlay = null;
  var activeStream = null;
  var fallbackUntil = 0;
  var PHOTO_PICKER_LABEL_SELECTORS = [
    'label.quick-mark-photo-drop',
    'label.treasure-map-details__photo-picker',
    'label.pfp-receipt-modal__camera'
  ];

  function canUseInAppCamera() {
    return !!(
      navigator.mediaDevices &&
      navigator.mediaDevices.getUserMedia &&
      window.DataTransfer &&
      window.File &&
      document.createElement('canvas').toBlob
    );
  }

  function stopStream() {
    if (activeStream) {
      activeStream.getTracks().forEach(function(track){ try { track.stop(); } catch (err) {} });
      activeStream = null;
    }
  }

  function closeOverlay() {
    stopStream();
    if (activeOverlay && activeOverlay.parentNode) {
      activeOverlay.parentNode.removeChild(activeOverlay);
    }
    activeOverlay = null;
    document.documentElement.classList.remove('pfp-camera-open');
  }

  function showMessage(overlay, message) {
    var node = overlay && overlay.querySelector('[data-pfp-camera-message]');
    if (node) node.textContent = message || '';
  }

  function findPhotoPickerLabel(target) {
    if (!target || !target.closest) return null;
    for (var i = 0; i < PHOTO_PICKER_LABEL_SELECTORS.length; i += 1) {
      var label = target.closest(PHOTO_PICKER_LABEL_SELECTORS[i]);
      if (label) return label;
    }
    return null;
  }

  function openFallbackPicker(input) {
    fallbackUntil = Date.now() + 1500;
    input.dataset.pfpNativeFallback = '1';
    var previousCapture = input.getAttribute('capture');
    input.removeAttribute('capture');
    try { input.click(); } catch (err) {}
    window.setTimeout(function(){
      if (previousCapture !== null) input.setAttribute('capture', previousCapture);
      delete input.dataset.pfpNativeFallback;
    }, 1800);
  }

  function assignFileToInput(input, file) {
    var dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    input.files = dataTransfer.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function captureFrame(input, video, overlay) {
    var width = video.videoWidth || 1280;
    var height = video.videoHeight || 720;
    if (!width || !height) {
      showMessage(overlay, 'Die Kamera ist noch nicht bereit. Bitte kurz warten.');
      return;
    }

    var maxWidth = 1280;
    if (width > maxWidth) {
      height = Math.round(height * (maxWidth / width));
      width = maxWidth;
    }

    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, width, height);
    canvas.toBlob(function(blob){
      if (!blob) {
        showMessage(overlay, 'Das Foto konnte nicht übernommen werden.');
        return;
      }
      var file = new File([blob], 'pfandpirat-fundfoto-' + Date.now() + '.jpg', { type: 'image/jpeg' });
      assignFileToInput(input, file);
      closeOverlay();
    }, 'image/jpeg', 0.82);
  }

  function buildOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'pfp-inapp-camera';
    overlay.innerHTML = '' +
      '<style>' +
      '.pfp-camera-open{overflow:hidden!important}' +
      '.pfp-inapp-camera{position:fixed;inset:0;z-index:2147483647;background:#07131c;color:#fff;display:flex;flex-direction:column;font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}' +
      '.pfp-inapp-camera__top{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;background:rgba(0,0,0,.35)}' +
      '.pfp-inapp-camera__title{font-size:16px;font-weight:800}' +
      '.pfp-inapp-camera__close{border:0;background:rgba(255,255,255,.14);color:#fff;border-radius:999px;width:40px;height:40px;font-size:24px;line-height:1}' +
      '.pfp-inapp-camera__stage{position:relative;flex:1;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#000}' +
      '.pfp-inapp-camera video{width:100%;height:100%;object-fit:cover}' +
      '.pfp-inapp-camera__message{position:absolute;left:16px;right:16px;bottom:16px;text-align:center;font-size:14px;background:rgba(0,0,0,.55);border-radius:10px;padding:8px 10px}' +
      '.pfp-inapp-camera__actions{display:grid;grid-template-columns:1fr 1.4fr;gap:10px;padding:12px 14px 18px;background:rgba(0,0,0,.55)}' +
      '.pfp-inapp-camera__actions button{min-height:48px;border-radius:14px;border:0;font-size:15px;font-weight:800}' +
      '.pfp-inapp-camera__secondary{background:#fff;color:#143042}' +
      '.pfp-inapp-camera__primary{background:#21b35b;color:#fff}' +
      '</style>' +
      '<div class="pfp-inapp-camera__top"><div class="pfp-inapp-camera__title">Foto aufnehmen</div><button type="button" class="pfp-inapp-camera__close" aria-label="Kamera schließen">×</button></div>' +
      '<div class="pfp-inapp-camera__stage"><video playsinline autoplay muted></video><div class="pfp-inapp-camera__message" data-pfp-camera-message>Kamera wird gestartet ...</div></div>' +
      '<div class="pfp-inapp-camera__actions"><button type="button" class="pfp-inapp-camera__secondary" data-pfp-gallery>Galerie</button><button type="button" class="pfp-inapp-camera__primary" data-pfp-capture>Foto übernehmen</button></div>';
    return overlay;
  }

  async function openInAppCamera(input) {
    if (activeOverlay) return;
    var overlay = buildOverlay();
    var video = overlay.querySelector('video');
    activeOverlay = overlay;
    document.body.appendChild(overlay);
    document.documentElement.classList.add('pfp-camera-open');

    overlay.querySelector('.pfp-inapp-camera__close').addEventListener('click', closeOverlay);
    overlay.querySelector('[data-pfp-gallery]').addEventListener('click', function(){
      closeOverlay();
      openFallbackPicker(input);
    });
    overlay.querySelector('[data-pfp-capture]').addEventListener('click', function(){
      captureFrame(input, video, overlay);
    });

    try {
      activeStream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      });
      video.srcObject = activeStream;
      await video.play().catch(function(){});
      showMessage(overlay, '');
    } catch (err) {
      showMessage(overlay, 'Die In-App-Kamera konnte nicht gestartet werden. Bitte Galerie nutzen oder ohne Foto fortfahren.');
    }
  }

  document.addEventListener('click', function(event){
    if (Date.now() < fallbackUntil) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var label = findPhotoPickerLabel(target);
    if (!label) return;
    var input = label.querySelector('input[type="file"][accept*="image"]');
    if (!input || input.dataset.pfpNativeFallback === '1') return;
    if (!canUseInAppCamera()) {
      input.removeAttribute('capture');
      return;
    }
    input.removeAttribute('capture');
    event.preventDefault();
    event.stopPropagation();
    openInAppCamera(input);
  }, true);

  document.addEventListener('visibilitychange', function(){
    if (document.hidden && activeOverlay) closeOverlay();
  });
})();
